import { useLocation } from 'react-router-dom';
import { PAGE_TITLES } from '@/constants/titles';

/**
 * Hook để lấy title của page hiện tại dựa trên route
 */
export function usePageTitle() {
  const location = useLocation();

  const getPageTitle = (pathname: string): string => {
    // Exact match trước (ưu tiên cao hơn startsWith)
    const exactMap: Record<string, string> = {
      '/': PAGE_TITLES.DASHBOARD,
      '/dashboard': PAGE_TITLES.DASHBOARD,
      '/virtual-account': PAGE_TITLES.VirtualAccount,
      '/customer-request': PAGE_TITLES.CustomerRequest,
      '/transaction': PAGE_TITLES.TRANSACTION,
      '/login': PAGE_TITLES.LOGIN,
      '/not-found': PAGE_TITLES.NOT_FOUND,
      '/card': PAGE_TITLES.CARD,
      '/cashback': PAGE_TITLES.CASHBACK,
      '/stablecoin-payments': PAGE_TITLES.STABLECOIN,

      // Settings sub-pages
      '/settings': PAGE_TITLES.SETTINGS,
      '/settings/personal/profile': PAGE_TITLES.SETTINGS_PROFILE, // 'My Profile'
      '/settings/personal/security': PAGE_TITLES.SETTINGS_PERSONAL_SECURITY,
      '/settings/users': PAGE_TITLES.SETTINGS_USERS,
      '/settings/company/profile': PAGE_TITLES.SETTINGS_COMPANY_PROFILE,
      '/settings/company/security': PAGE_TITLES.SETTINGS_COMPANY_SECURITY,
      '/settings/notification/balance-alert-rules': PAGE_TITLES.SETTINGS_BALANCE_ALERT_RULES,
      '/settings/notification/bot': PAGE_TITLES.SETTINGS_BOT,
      '/settings/notification/transaction-rules': PAGE_TITLES.SETTINGS_TRANSACTION_RULES,
    };

    if (exactMap[pathname]) return exactMap[pathname];

    // Fallback: startsWith cho các route có params (/dashboard/*, /cashback/:id...)
    if (pathname.startsWith('/dashboard')) return PAGE_TITLES.DASHBOARD;

    return PAGE_TITLES.DASHBOARD;
    // Exact matches
    switch (pathname) {
      case '/':
        return PAGE_TITLES.DASHBOARD;
      case '/dashboard':
        return PAGE_TITLES.DASHBOARD;
      case '/virtual-account':
        return PAGE_TITLES.VirtualAccount;
      case '/customer-request':
        return PAGE_TITLES.CustomerRequest;
      case '/transaction':
        return PAGE_TITLES.TRANSACTION;
      case '/login':
        return PAGE_TITLES.LOGIN;
      case '/not-found':
        return PAGE_TITLES.NOT_FOUND;
      case '/card':
        return PAGE_TITLES.CARD;
      case '/settings':
        return PAGE_TITLES.SETTINGS;
      case '/settings/company/profile':
        return PAGE_TITLES.SETTINGSCOMPANYPROFILE;
      case '/settings/company/security':
        return PAGE_TITLES.SETTINGSCOMPANYSECURITY;
      default:
        // Nếu không tìm thấy, trả về "dashboard" làm mặc định
        return PAGE_TITLES.DASHBOARD;
    }
  };

  return getPageTitle(location.pathname);
}
